// extracted by mini-css-extract-plugin
export default {"cls1":"Header-cls1_p4s","cls2":"Header-cls2__X6 Header-cls1_p4s"};